import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getCredits,
    getCreditsReport,
    createCredit,
    updateCredit,
    deleteCredit
}

function getCredits(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/credits`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getCreditsReport() {
    return new Promise((resolve, reject) => {

        Superagent
            .get(`${HOST_API}/credits/report`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function createCredit(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/credits`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateCredit(creditId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/credits/${creditId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteCredit(creditId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/credits/${creditId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}